import React, { memo } from 'react'
import { IconInfoCircle } from '@tabler/icons-react'
import StarRating from '../../components/StarRating'
import { Tooltip } from 'react-tooltip'

interface DataQualityScoreProps {
  score: number
}

const DataQualityScore: React.FC<DataQualityScoreProps> = memo(({ score }) => {
  return (
    <div
      className={`bg-[var(--surface-elevated)] p-1 rounded-[5px] shadow-md mx-2 my-1`}
      data-testid="data-quality-score">
      <div className="flex items-center">
        <span
          className="me-50 text-subheading font-semibold text-lg"
          data-testid="data-quality-score-title">
          Data Quality Score
        </span>
        <IconInfoCircle
          size={16}
          className="text-subheading cursor-pointer"
          data-tooltip-id="data-score"
          data-testid="info-icon"
        />
        <Tooltip
          id="data-score"
          place="bottom"
          className="rounded-lg px-4 py-2 max-w-xs text-center !z-[9999]">
          Data Quality score measures how trusted, complete, and consistent a dataset is
        </Tooltip>
      </div>
      <div className="flex justify-center items-center w-full mt-2 mb-1">
        <div className="flex items-center">
          {/* Circle with score */}
          <span
            className="flex items-center justify-center font-bold text-lg bg-primary text-white w-[45px] h-[45px] rounded-full z-10 shadow-md relative"
            data-testid="data-quality-score-value">
            {(() => {
              const value = (score * 0.05).toFixed(1)
              return value === '0.0' ? '0' : value
            })()}
          </span>
          {/* Badge with stars */}
          <span className="flex items-center bg-surface shadow ps-8 pr-4 py-2 rounded-r-full rounded-l-[40px] h-[40px] -ml-6 z-5">
            <StarRating id="ratings" size={30} value={score * 0.05} />
          </span>
        </div>
      </div>
    </div>
  )
})

export default DataQualityScore
